/**
 * Cache identity for workspace secrets and variables.
 *
 * Typed factories rather than inline arrays so the query and every invalidation
 * that follows a mutation cannot drift apart (constitution §2.6). Every key is
 * scoped by workspace: entries belong to exactly one, and there is no
 * account-level or inherited tier for a key to have to account for.
 *
 * `all` exists alongside `list` as the invalidation target. Today they cover the
 * same single query, but mutations invalidate `all` — so a future per-entry
 * query joins the cache without anyone having to revisit what invalidation
 * means here.
 */
export const secretKeys = {
  all: (workspaceId: string) => ['workspace-secrets', workspaceId] as const,
  list: (workspaceId: string) =>
    ['workspace-secrets', workspaceId, 'list'] as const,
};
